var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPodium3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 48,
    viewBox: "0 0 24 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20996 15L2.65996 7.14C2.46376 6.80087 2.37149 6.41159 2.3946 6.02048C2.41771 5.62937 2.55518 5.25366 2.78996 4.94L4.39996 2.8C4.58625 2.55161 4.82782 2.35 5.10553 2.21115C5.38324 2.07229 5.68947 2 5.99996 2H18C18.3104 2 18.6167 2.07229 18.8944 2.21115C19.1721 2.35 19.4137 2.55161 19.6 2.8L21.2 4.94C21.4363 5.25265 21.5755 5.62784 21.6004 6.01897C21.6253 6.4101 21.5347 6.79992 21.34 7.14L16.79 15",
    stroke: "#00A0DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 12L5.12012 2.20001",
    stroke: "#00A0DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12L18.88 2.20001",
    stroke: "#00A0DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7H16",
    stroke: "#00A0DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C14.7614 22 17 19.7614 17 17C17 14.2386 14.7614 12 12 12C9.23858 12 7 14.2386 7 17C7 19.7614 9.23858 22 12 22Z",
    stroke: "#00A0DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8057 42.2021C11.1787 42.2021 10.5957 42.0352 10.0566 41.7012C9.52344 41.373 9.0957 40.9336 8.77344 40.3828C8.45703 39.8262 8.29883 39.2197 8.29883 38.5635V37.7549C8.29883 37.6904 8.32227 37.6582 8.36914 37.6582H10.3906C10.4492 37.6582 10.4785 37.6904 10.4785 37.7549V38.5635C10.4785 38.9561 10.6045 39.2959 10.8564 39.583C11.1084 39.8643 11.4248 40.0049 11.8057 40.0049C12.2275 40.0049 12.5586 39.8584 12.7988 39.5654C13.0391 39.2666 13.1592 38.9326 13.1592 38.5635V38.0801C13.1592 37.7051 13.042 37.3682 12.8076 37.0693C12.5732 36.7705 12.2773 36.6211 11.9199 36.6211H11.2168C11.1582 36.6211 11.1289 36.5889 11.1289 36.5244L11.1465 34.5117C11.1465 34.4648 11.1699 34.4414 11.2168 34.4414H11.9199C12.2422 34.4414 12.5293 34.3154 12.7812 34.0635C13.0332 33.8115 13.1592 33.4805 13.1592 33.0703V32.8242C13.1592 32.4375 13.0303 32.1094 12.7725 31.8398C12.5146 31.5703 12.1924 31.4355 11.8057 31.4355C11.4365 31.4355 11.123 31.5703 10.8652 31.8398C10.6074 32.1094 10.4785 32.4375 10.4785 32.8242V33.6855C10.4785 33.7441 10.4551 33.7734 10.4082 33.7734H8.38672C8.33984 33.7734 8.31641 33.7441 8.31641 33.6855V32.7275C8.31641 32.0713 8.4834 31.4854 8.81738 30.9697C9.14551 30.4541 9.57617 30.0439 10.1094 29.7393C10.6426 29.4287 11.208 29.2734 11.8057 29.2734C12.4561 29.2734 13.0479 29.4316 13.5811 29.748C14.1143 30.0703 14.5361 30.4951 14.8467 31.0225C15.1631 31.5498 15.3213 32.1299 15.3213 32.7627V33.0527C15.3213 33.5801 15.2334 34.0371 15.0576 34.4238C14.8818 34.8047 14.6387 35.1709 14.3281 35.5225C14.6387 35.8799 14.8848 36.2725 15.0664 36.7002C15.248 37.1279 15.3389 37.5674 15.3389 38.0186V38.5635C15.3389 39.2314 15.1807 39.8438 14.8643 40.4004C14.542 40.9512 14.1143 41.3906 13.5811 41.7188C13.0479 42.041 12.4561 42.2021 11.8057 42.2021Z",
    fill: "#00A0DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPodium3);
export default __webpack_public_path__ + "static/media/icon_podium3.9017d6106e7525e1b4858c6014147cc0.svg";
export { ForwardRef as ReactComponent };